import { css } from '@emotion/core'
import { colors, measures, font } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

export const mobileContainer = css`
  background-color: ${colors.grays.gray6} !important;
  min-height: 100vh;
  min-height: 100dvh; /* Use dynamic viewport height */
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 1000;
  overflow: hidden;
  
  /* Handle safe areas for mobile devices */
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  
  /* Override any parent container backgrounds */
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${colors.grays.gray6};
    z-index: -1;
  }
  
  /* Ensure no default background colors from browser */
  * {
    background-color: inherit;
  }
`

export const header = css`
  display: flex;
  align-items: center;
  padding: ${6 * unit}px ${4 * unit}px ${6 * unit}px;
  position: relative;
  flex-shrink: 0;
  margin-top: ${1.8 * unit}px;
`

export const backArrow = css`
  color: #ffffff;
  font-size: 22px;
  cursor: pointer;
  user-select: none;
  position: absolute;
  left: ${4 * unit}px;
`

export const headerContent = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const title = css`
  color: ${colors.white12};
  font-size: 22px;
  font-weight: ${font.weight.bold};
  font-style: italic;
  margin: 0;
  line-height: 1.2;
  text-align: center;
  background: transparent !important;
  background-color: transparent !important;
  display: block;
`

export const formContainer = css`
  flex: 1;
  padding: 0 ${4 * unit}px ${2 * unit}px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

export const description = css`
  color: ${colors.grays.gray2};
  font-size: 14px;
  font-weight: ${font.weight.normal};
  margin: 0;
  text-align: center;
  line-height: 1.4;
`

export const form = css`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const inputField = css`
  background-color: transparent;
  
  /* Style the input labels */
  label {
    color: ${colors.white12} !important;
    font-size: 16px;
    margin-bottom: ${unit}px;
  }
  
  /* Style the input elements */
  input {
    background-color: transparent !important;
    border: 1px solid ${colors.grays.gray4} !important;
    border-radius: 8px !important;
    padding: ${2 * unit}px ${1.5 * unit}px !important;
    color: ${colors.white100} !important;
    font-size: 16px !important;
    
    &::placeholder {
      color: ${colors.grays.gray2} !important;
      font-size: 13px !important;
    }
    
    &:focus {
      border-color: ${colors.white100} !important;
      outline: none !important;
    }
  }
`

export const spacer = css`
  flex: 0.5;
`

export const buttonContainer = css`
  margin-top: ${60 * unit}px;
  padding: 0;
  flex-shrink: 0;
`

export const resetButton = css`
  width: 100%;
  background-color: ${colors.greens.green2} !important;
  border: none !important;
  border-radius: 50px !important;
  height: 48px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer;
  transition: background-color 0.2s ease !important;
  box-shadow: 0 0 0 transparent !important;
  
  &:hover {
    background-color: ${colors.greens.green3} !important;
  }
  
  &:active {
    background-color: ${colors.greens.green4} !important;
  }
  
  &:disabled {
    background-color: ${colors.grays.gray4} !important;
    cursor: not-allowed;
  }
`

export const buttonText = css`
  color: black !important;
  font-size: 13px !important;
  font-weight: ${font.weight.semiBold} !important;
  margin: 0 !important;
  text-transform: none !important;
`
